import React, { Component } from 'react';
import * as apis from '../../../common-utils/api_urls'
import * as translationUtils from '../../../common-utils/translation_utils'

/**
 * OrderSearch Class renders Order Search sub-section
 */
class OrderSearch extends Component {

  constructor(props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    window.startDatePicker();
    this.$ = window.jQuery;
    if(Object.keys(this.props.orderData.filters)[0]!==""){
      if(this.props.orderData.filters.keyword!==undefined)
        this.$('input[name=searchKeyword]').val(this.props.orderData.filters.keyword.replace(/%20/g,' '));
      this.$('input[name=fromDate]').val(this.props.orderData.filters.from);
      this.$('input[name=toDate]').val(this.props.orderData.filters.to);
      this.$('select[name=orderStatus]').val(this.props.orderData.filters.orderstatus);
      this.$('select[name=orderPlacedWithin]').val(this.props.orderData.filters.orderplacedwithin);
      if(this.props.orderData.filters.searchterm!==undefined)
        this.$('select[name=searchType]').val(this.props.orderData.filters.searchterm);
      this.$('#filter-submit').click();
    }
  }

  componentDidUpdate(){
    if(Object.keys(this.props.orderData.filters)[0]===""){
      this.$('input[name=searchKeyword]').val('');
      window.datepickers.datepicker('update', '');
      this.$('select[name=orderStatus]').val('');
      this.$('select[name=orderPlacedWithin]').val('');
    }
  }

  /**
   * Handles URL change and passes order URL to MainWrapper Callback on Form Submit.
   */
  handleSubmit(e){
    window.loader(true);
    e.preventDefault();
    //var filters = JSON.parse('{}');
    var searchKeyword = this.$('input[name=searchKeyword]').val();
    var searchType = this.$('select[name=searchType]').val();
    var fromDate = this.$('input[name=fromDate]').val();
    var toDate = this.$('input[name=toDate]').val();
    var orderStatus = this.$('select[name=orderStatus]').val();
    var orderPlacedWithin = this.$('select[name=orderPlacedWithin]').val();

    var filters = JSON.parse('{}');
    var searchCheckFlag = false;
    var dateRangeCheck = true;

    if(searchKeyword.length>0){
      filters['keyword'] = [searchType,searchKeyword];
      searchCheckFlag = true;
      // this.props.callbackFromParent(apis.getOrderUrl(this.props.orderData.type,searchKeyword,'keyword'), 'keyword='+searchKeyword);
    }
    if(fromDate.length===10 && toDate.length===10){
      if(new Date(toDate.replace(/-/g,'/'))>=new Date(fromDate.replace(/-/g,'/'))){
        filters['daterange'] = [fromDate,toDate];
        searchCheckFlag = true;
        //this.props.callbackFromParent(apis.getOrderUrl(this.props.orderData.type, [fromDate.replace(/-/g,''),toDate.replace(/-/g,'')], 'daterange'), 'from='+fromDate+'&to='+toDate)
      }else{
        dateRangeCheck = false;
        window.alert("Date Range is Invalid");
        window.loader(false);
      }
    }
    if(orderStatus!==''){
      filters['orderstatus'] = orderStatus;
      searchCheckFlag = true;
      //this.props.callbackFromParent(apis.getOrderUrl(this.props.orderData.type,orderStatus,'orderstatus'), 'orderstatus='+orderStatus);
    }if(orderPlacedWithin!=='' && (fromDate.length===0 && toDate.length===0)){
      filters['orderplacedwithin'] = orderPlacedWithin;
      searchCheckFlag = true;
      //this.props.callbackFromParent(apis.getOrderUrl(this.props.orderData.type, [dateBeforeXMonths,currentDate], 'daterange'), 'orderplacedwithin='+orderPlacedWithin)
    }else if(orderPlacedWithin!=='' && dateRangeCheck){
      dateRangeCheck = false;
      window.alert("Please Select either of Date-Range or Order Placed Within");
      window.loader(false);
    }

    if(!searchCheckFlag && dateRangeCheck){
      window.alert("Invalid Search Parameters");
      window.loader(false);
    }else if(dateRangeCheck){
      this.props.callbackFromParent(apis.getOrderUrl(this.props.orderData.type, filters),filters)
    }

    this.$('.button.accent-button.round-button.small-button.submit-button').blur();
    
  }

  render() {
    return (
      <div className="ph-nav-group">
          <div className="ph-nav-group__header">{translationUtils.getTranslation(1839,'Order Search')}</div>
            <form className="ph-form" onSubmit={this.handleSubmit}>
                <label className="ph-search__label" htmlFor="keyword">{translationUtils.getTranslation(1541,'Search By')}</label>
                <select id="searchType" name="searchType">
                  <option value="OrderNo" defaultValue>{translationUtils.getTranslation(1852,"Order Number")}</option>
                  <option value="CustomerPONO">{translationUtils.getTranslation(1853,"Customer PO")}</option>
                  <option value="ItemNumber">{translationUtils.getTranslation(1022,"Part Number")}</option>
                </select>
                <input type="text" name="searchKeyword" id="searchBox" />

                <label className="ph-search__label" htmlFor="daterange">{translationUtils.getTranslation(1841,"Order Date Range")}</label>
                <div id="datepicker" className="input-group date" data-date-format="mm-dd-yyyy">
                <input className="form-control" name="fromDate" type="text" readOnly placeholder={translationUtils.getTranslation(93, 'Start Date')}/>
                <span className="input-group-addon"><i className="fas fa-calendar-alt"></i></span>

                </div>
                <div id="datepicker2" className="input-group date" data-date-format="mm-dd-yyyy">
                <input className="form-control" name="toDate" type="text" readOnly placeholder={translationUtils.getTranslation(94, 'End Date')}/>
                <span className="input-group-addon"><i className="fas fa-calendar-alt"></i></span>
                </div>

                <label className="ph-search__label" htmlFor="status">{translationUtils.getTranslation(1842,"Status")}</label>
                <select id="status" name="orderStatus">
                    <option value='' defaultValue>{translationUtils.getTranslation(133,"Select")}</option>
                    <option value="Accepted">{translationUtils.getTranslation(1843,"Accepted")}</option>
                    <option value="Delayed">{translationUtils.getTranslation(1844,"Delayed")}</option>
                    <option value="Held">{translationUtils.getTranslation(1845,"Held")}</option>
                    {(this.props.orderData.type==='all')?(<option value="Shipped">{translationUtils.getTranslation(1846,"Shipped")}</option>):(console.log('Open Orders'))}
                  </select>
                
                <label className="ph-search__label" htmlFor="timeline">{translationUtils.getTranslation(1858,"Order Placed Within")}</label>
                <select id="timeline" name="orderPlacedWithin">
                    <option value='' defaultValue>{translationUtils.getTranslation(133,"Select")}</option>
                    <option value="30Days">{translationUtils.getTranslation(1860,"Last 30 Days")}</option>
                    <option value="6Months">{translationUtils.getTranslation(1859,"Last 6 Months")}</option>
                    <option value="CurrentYear">{translationUtils.getTranslation(1861,"Current Year")}</option>
                    <option value="LastYear">{translationUtils.getTranslation(1862,"Last Year")}</option>
                  </select>

                <button type="submit" id='filter-submit' className="button accent-button round-button small-button submit-button">{translationUtils.getTranslation(46,"Search")}</button>
            </form>
      </div>
    );
  }
}

export default OrderSearch;
